import {
    Avatar,
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import React, { useState } from "react";
import RegisterImage from "../Images/Register.svg";
import "./Register.css";
import InputField from "../Inputfield/inputField";

function Register() {
    const [values, setValues] = useState({
        name: "",
        username: "",
        email: "",
        password: "",
        gender: "",
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    return (
        <div className="flex flex-wrap md:justify-evenly place-content-center h-screen items-center dark:backdrop-blur-lg dark:bg-opacity-90  dark:text-slate-300">
            {/* register image */}
            <img
                className="hidden w-1/6  md:flex duration-500 ease-in-out"
                src={RegisterImage}
                alt="Register"
            />
            <div>
                <br />
                <div className="flex flex-col justify-center items-center">
                    <div className=" ">
                        <Avatar sx={{ bgcolor: "#0075E1" }}>
                            <LockOutlinedIcon />
                        </Avatar>
                    </div>
                    <h1 className="text-4xl text-gray-700 dark:text-gray-300 font-medium">
                        Register
                    </h1>
                </div>
                <br />
                {/* <legend class="css-1ftyaf0">
                    <span>Required&nbsp;*</span>
                </legend> */}
                <div className="md:grid md:gap-3 md:grid-cols-2 justify-start items-center">
                    <InputField
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Name *"
                        autocomplete="name"
                    />
                    <InputField
                        type="text"
                        name="username"
                        id="username"
                        placeholder="Username *"
                        autocomplete=""
                    />
                    <InputField
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email *"
                        autocomplete="email"
                    />
                    <InputField
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Password *"
                        autocomplete=""
                    />
                </div>
                {/* <input
                    className="form duration-1000 text-black dark:text-gray-300 ease-in-out bg-transparent no-underline border-blue-600 focus:border-dashed outline-none border-2 p-3  rounded-md  hover:border-blue-600 active:border-blue-600"
                    type="text"
                    name="Name "
                    autoComplete="name"
                    id="name"
                    placeholder="Name"
                /> */}
                <br />
                <br />
                <Container component="main" maxWidth="xs">
                    <div>
                        <form
                            // onSubmit={handleSubmit}
                            autoComplete="on">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    {values.name.length < 20 ? (
                                        <TextField
                                            autoComplete="name"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label="Name"
                                            name="name"
                                            autoFocus
                                            helperText=""
                                            onChange={handleChange}
                                            value={values.name}
                                        />
                                    ) : (
                                        <TextField
                                            autoComplete="name"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            error
                                            label="Name"
                                            name="name"
                                            autoFocus
                                            helperText="Max 20 character allowed"
                                            onChange={handleChange}
                                            value={values.name}
                                        />
                                    )}
                                </Grid>
                                {/* {errors.email && (
                                    <p className="Err">{errors.email}</p>
                                )} */}

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label="Username"
                                        name="username"
                                        onChange={handleChange}
                                        value={values.username}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        type="email"
                                        name="email"
                                        autoComplete="email"
                                        onChange={handleChange}
                                        value={values.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label="Password"
                                        name="password"
                                        type="password"
                                        onChange={handleChange}
                                        value={values.password}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormControl
                                        variant="outlined"
                                        style={{
                                            minWidth: "100%",
                                        }}>
                                        <InputLabel id="demo-simple-select-outlined-label">
                                            Gender
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={values.gender}
                                            onChange={handleChange}
                                            required
                                            label="Gender"
                                            name="gender">
                                            <MenuItem value={"Male"}>
                                                Male
                                            </MenuItem>
                                            <MenuItem value={"Female"}>
                                                Female
                                            </MenuItem>
                                            <MenuItem value={"Other"}>
                                                Other
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <br />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary">
                                Register
                            </Button>
                        </form>
                        <br />
                        <br />
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Register;
